import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ISubheaderLeftSection, ISubheaderRightSection } from '../components/sub-header/sub-header.modal';
import { SharedCallsService } from '../../shared/services/shared-calls.service';


@Injectable()
export class SubheaderHandlerService {
    private leftSectionSource = new Subject<ISubheaderLeftSection>();
    private rightSectionSource = new Subject<ISubheaderRightSection>();
    private currentPageName = new Subject<any>();
    private saveProgressInitiated = new Subject<string>();
    private enableSaveProgress = new Subject<boolean>();
    private hideSaveProgress = new Subject<boolean>();
    private filtersObjectReceived = new Subject<any>();
    private closeButtonClicked = new Subject<string>();
    private closeDanglingSession = new Subject<string>();
    private lockDetails = new Subject<any>();
    private caseDetails = new Subject<any>();
    filtersObject: any = {
        'customers': [],
        'regions': [],
        'revenues': [],
        'status': []
      };

    subheaderLeftSection$ = this.leftSectionSource.asObservable();
    subheaderRightSection$ = this.rightSectionSource.asObservable();
    currentPageName$ = this.currentPageName.asObservable();
    saveProgressInitiated$ = this.saveProgressInitiated.asObservable();
    enableSaveProgress$ = this.enableSaveProgress.asObservable();
    hideSaveProgress$ = this.hideSaveProgress.asObservable();
    filtersObjectReceived$ = this.filtersObjectReceived.asObservable();
    closeButtonClicked$ = this.closeButtonClicked.asObservable();
    closeDanglingSession$ = this.closeDanglingSession.asObservable();
    lockDetails$ = this.lockDetails.asObservable();
    caseDetails$ = this.caseDetails.asObservable();

    savedCurrentPageName: string;
    caseId: string;

    constructor(
        private sharedService: SharedCallsService
    ) {

    }
    updateLeftSection(newData: ISubheaderLeftSection) {
        this.leftSectionSource.next(newData);
    }

    updateRightSection(newData: ISubheaderRightSection) {
        this.rightSectionSource.next(newData);
    }

    saveProgress(currentPage) {
        this.saveProgressInitiated.next(currentPage);
    }

    updateCurrentPageName(pageName: string, caseId: string) {
        this.caseId = caseId;
        this.savedCurrentPageName = pageName;
        const PageNameCaseId = {
            pageName: this.savedCurrentPageName,
            caseId: this.caseId
        };
        this.currentPageName.next(PageNameCaseId);
    }

    enableSaveProgressForPage(enableSaveProgress: boolean) {
        this.enableSaveProgress.next(enableSaveProgress);
    }

    hideSaveProgressForPage(hideSaveProgress: boolean) {
        this.hideSaveProgress.next(hideSaveProgress);
    }

    sendFiltersValues(filtersObject) {
        this.filtersObject = filtersObject;
        this.filtersObjectReceived.next(this.filtersObject);
    }

    closeClicked(pageName) {
        this.closeButtonClicked.next(pageName);
    }

    closeDanglingSessionClicked() {
        this.closeDanglingSession.next(this.savedCurrentPageName);
    }

    updateLockStatus(lockStatus: boolean) {
        this.lockDetails.next(lockStatus);
    }

    updateCaseStatus(caseStatus) {
        this.caseDetails.next(caseStatus);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/services/subheader-handler.service.ts